import { formatMessage } from 'utils/utils';

export const isInViewport = (elem) => {
  var bounding = elem.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const isElementInContainerViewport = (
  targetElement,
  containerElement
) => {
  const targetRect = targetElement.getBoundingClientRect();
  const containerRect = containerElement.getBoundingClientRect();
  return (
    targetRect.top >= containerRect.top &&
    targetRect.bottom <= containerRect.bottom &&
    targetRect.left >= containerRect.left &&
    targetRect.right <= containerRect.right
  );
};

export const removeSignatureFromContent = (message) => {
  var temp = document.createElement('div');
  temp.innerHTML = formatMessage(message);
  let elementToRemove = temp.querySelector('#user-signature');
  if (elementToRemove) {
    elementToRemove.remove();
  }
  let updatedHtmlString = temp.innerHTML;
  return updatedHtmlString;
};

export const handleDropdownPosition = () => {
  let parent = document.getElementById('label-container');
  let button = document.getElementById('add-label');
  if (button) {
    let buttonOffset = button.offsetLeft;
    if (buttonOffset > parent.clientWidth / 2) {
      return true;
    } else {
      return false;
    }
  }
};
